<script setup lang="ts">
import { useFilesStore } from "@/stores/files";
import { computed } from "vue";

const fileStore = useFilesStore();
const sessionID = computed(() => fileStore.currentSession?.sessionId ?? "");
</script>
<template>
    <header class="header text-secondary">
        <div class="header__organization">UWA</div>
        <div class="header__app">UPLOADER SESSION</div>
        <div class="header__id">id:{{ sessionID }}</div>
    </header>
</template>

<style scoped lang="scss">
.header {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    grid-template-areas:
        "organization app"
        "organization id";
    padding: 20px 0;

    &__organization {
        grid-area: organization;
        font-size: 53px;
        justify-self: end;
        align-self: center;
        line-height: 1;
        padding-right: 10px;
    }

    &__app {
        grid-area: app;
        font-size: 30px;
        align-self: center;
        line-height: 25px;
        align-self: flex-end;
    }

    &__id {
        grid-area: id;
        font-size: 13px;
        line-height: 1;
    }
}
</style>
